<form [formGroup]="mainForm">
  <nb-card>
    <nb-card-header>
      <div class="title">
        <span>
          {{ title }}
        </span>
        <span class="description" *ngIf="isEditMode"> On {{selectedDateString}}</span>
      </div>
    </nb-card-header>

    <nb-card-body class="row">
      <div class="col-lg-12">
        <div class="form-group row">
          <label class="col-sm-4 col-form-label"><span>Route Name<span class="required">*</span></span></label>
          <div class="col-sm-8">
            <input nbInput fullWidth shape="rectangle" type="text" placeholder="" formControlName="name"
              [status]="(mainForm.controls.name.invalid && mainForm.controls.name.touched) ? 'danger' : 'basic'"
              autocomplete="null" />
            <span [ngxAppValidationMessageFor]="mainForm.controls.name" class="error-message">
            </span>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="form-group row">
          <label class="col-sm-4 col-form-label"><span>Driver<span class="required">*</span></span></label>
          <div class="col-sm-8">
            <ngx-autocomplete [data]="driverDropdownData" [control]="mainForm.controls.driver"
              (onFilterChange)="onDriverFilterChange($event)"
              (focusout)="onAutoCompleteFocusOut(mainForm.controls.driver)" fullWidth>
            </ngx-autocomplete>
            <!-- <span [ngxAppValidationMessageFor]="mainForm.controls.driverId" class="error-message">
            </span> -->
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="form-group row">
          <label class="col-sm-4 col-form-label"><span>Vehicle<span class="required">*</span></span></label>
          <div class="col-sm-8">
            <ngx-autocomplete [data]="vehicleDropdownData" [control]="mainForm.controls.vehicle"
              (onFilterChange)="onVehicleFilterChange($event)"
              (focusout)="onAutoCompleteFocusOut(mainForm.controls.vehicle)" fullWidth>
            </ngx-autocomplete>
            <!-- <span [ngxAppValidationMessageFor]="mainForm.controls.vehicleId" class="error-message">
            </span> -->
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="form-group row">
          <label class="col-sm-4 col-form-label"><span>Route Day<span class="required">*</span></span></label>
          <div class="col-sm-8">
            <ngx-select required="true" [control]="mainForm.controls.routeDay" [list]="dayOfWeekDropDown">
            </ngx-select>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="form-group row">
          <label class="col-sm-4 col-form-label"><span>Start Date<span class="required">*</span></span></label>
          <div class="col-sm-8">
            <span class="icon"><i class="fas fa-calendar-alt"></i></span>
            <input nbInput fullWidth [nbDatepicker]="startDate" [formControl]="mainForm.controls.startDate"
              (focusout)="isGreaterThanStartDate()"
              [status]="(mainForm.controls.startDate.invalid && mainForm.controls.startDate.touched) ? 'danger' : 'basic'">
            <nb-datepicker #startDate [format]="dateFormat" [min]="minDate"></nb-datepicker>
            <span [ngxAppValidationMessageFor]="mainForm.controls.startDate" class="error-message">
            </span>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="form-group row">
          <label class="col-sm-4 col-form-label">End Date</label>
          <div class="col-sm-8">
            <span class="icon"><i class="fas fa-calendar-alt"></i></span>
            <input nbInput fullWidth [nbDatepicker]="endDate" [formControl]="mainForm.controls.endDate"
              (focusout)="isGreaterThanStartDate()"
              [status]="(mainForm.controls.endDate.invalid && mainForm.controls.endDate.touched) ? 'danger' : 'basic'">
            <nb-datepicker #endDate [format]="dateFormat" [min]="minDate"></nb-datepicker>
            <span [ngxAppValidationMessageFor]="mainForm.controls.endDate" class="error-message">
            </span>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="form-group row">
          <label class="col-sm-4 col-form-label">Start Point</label>
          <div class="col-sm-8">
            <ngx-ggAutocomplete type="address" [address]="currentStartPointAddress"
              (onLocationSelected)="onLocationSelected($event)"
              (onChange)="onLocationSearchChange($event)"></ngx-ggAutocomplete>
            <span *ngIf="isSelectedLocation" class="warning-message">
              System cannot get location from an address entered manually!
            </span>
          </div>
        </div>
      </div>
      <div class="col-lg-12" *ngIf="isEditMode">
        <div class="form-group row">
          <label class="col-sm-4 col-form-label"><span>Apply On</span> <span class="required">*</span></label>
          <div class="col-sm-8">
            <ngx-radio [list]="ApplyOnList" [controlName]="'applyOn'" [inLine]="true">
            </ngx-radio>
            <span [ngxAppValidationMessageFor]="mainForm.controls.applyOn" class="error-message">
            </span>
          </div>
        </div>
      </div>
    </nb-card-body>

    <nb-card-footer class="row">
      <div class="col-6">
        <ngx-button status="primary" [isLoading]="isLoading" class="button-save" fullWidth [type]="'submit'"
          (click)="save()">
          {{ isEditMode ? 'Save' : 'Create'}}
        </ngx-button>
      </div>

      <div class="col-6">
        <ngx-button status="info" class="button-cancel" fullWidth (click)="cancel()">Cancel</ngx-button>
      </div>
    </nb-card-footer>
  </nb-card>
</form>